<!--Table-->
<div class="table-main-body">
	<div class="InfoHeading">
		<h4>Section Details:</h4>
	</div>

	<p-table
		*ngIf="lstSection.length > 0"
		#mydt
		[value]="lstSection"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedSection"
		dataKey="SectionID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[1, 5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--Semester-->
				<th>
					<p-columnFilter type="text" field="Semester" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Day-->
				<th>
					<p-columnFilter type="text" field="Day" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--PeriodNo-->
				<th>
					<p-columnFilter type="text" field="PeriodNo" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--InstructorDesc-->
				<th>
					<p-columnFilter type="text" field="InstructorDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--RoomNo-->
				<th>
					<p-columnFilter type="text" field="RoomNo" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="Semester">Semester<p-sortIcon field="Semester"></p-sortIcon></th>
				<th pSortableColumn="Day">Day<p-sortIcon field="Day"></p-sortIcon></th>
				<th pSortableColumn="PeriodNo">Period<p-sortIcon field="PeriodNo"></p-sortIcon></th>
				<th pSortableColumn="InstructorDesc">Instructor<p-sortIcon field="InstructorDesc"></p-sortIcon></th>
				<th pSortableColumn="RoomNo">Room<p-sortIcon field="RoomNo"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Section>
			<tr [pSelectableRow]="Section">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ Section[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>

	<div class="InfoHeading" *ngIf="SectionID == -1">
		<h4>Select a Section</h4>
	</div>

	<div class="InfoHeading" *ngIf="lstSection.length == 0 && SectionID != -1">
		<h4>No Records Found</h4>
	</div>
</div>
